/**
 * The regex here currently accounts for: `<word> || <part of speech> || <definition>` and `<word> (<part of speech>): <definition>`.
 * @param {string} termString - The key term string. It appears as '${word} (${part of speech}): ${definition}'
 * @returns {object}
 */

const keyTermObjects = (termString) => {
  const pattern = "\\([^)]+\\):|\\|\\|\\s*[^|]+\\s*\\|\\|";
  const regexPattern = new RegExp(pattern, "g");
  const [term, definition] = termString.split(regexPattern);

  const word = term.replace(/\([^)]*\)/g, "");

  return {
    term: word.toLowerCase().trim(),
    definition: definition?.trim(),
  };
};

/**
 * Splits the algorithm output string into substrings and remaps
 * those substrings, returning an array of objects containing terms and definitions
 * @param {string} keyTermString
 * @returns {array}
 */
const extractKeyTerms = (keyTermString) => {
  if (!keyTermString) return;

  const keyTermArray = keyTermString.split(/\n\n\*?|\n\*/);

  const termObjects = keyTermArray.map((keyTerm) => {
    return keyTermObjects(keyTerm);
  });

  return termObjects.filter((keyTerm) => !!keyTerm.definition);
};

export default extractKeyTerms;
